<app-prescription-edit [entry]="entry"></app-prescription-edit>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Fermer</button>
  <button mat-button (click)="save()">Enregistrer</button>
</mat-dialog-actions>